import Vue from 'vue';

Vue.component('share-component', {
    data() {
        return {
            showShareOptions: false,
            linkCopied: false,
            copiedTimeout: null,
        };
    },

    mounted() {

    },

    watch: {

    },

    methods: {
        toggleShare() {
            this.showShareOptions = !this.showShareOptions;
        },

        copyLink(url) {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(url)
                .then(() => this.confirmCopy())
                .catch(() => this.copyLinkFallback(url));
                return;
            }

            this.copyLinkFallback(url);
        },

        copyLinkFallback(url) {
            const input = document.createElement('input');
            input.value = url;
            input.setAttribute('style', 'position:fixed;top:0;left:0;opacity:0;');
            document.body.appendChild(input);
            input.select();
            input.setSelectionRange(0, url.length);

            const copied = document.execCommand('copy');
            document.body.removeChild(input);

            if (copied) {
                this.confirmCopy();
            }
        },

        confirmCopy() {
            this.linkCopied = true;

            clearTimeout(this.copiedTimeout);
            this.copiedTimeout = setTimeout(() => {
                this.linkCopied = false;
            }, 3000);
        },
    },
});
